package com.example.mystybag.appCore.model.pages

/**
 * Nomenclature for "Could be better?" review aspects.
 * User can select up to 3 of these when leaving a review.
 */
enum class ReviewCouldBeBetterAspect(val stringKey: String) {
    PRICE("review_could_better_price"),
    PICKUP_TIME("review_could_better_pickup_time"),
    BAG_VARIETY("review_could_better_bag_variety"),
    PACKAGING("review_could_better_packaging"),
    STAFF_ATTITUDE("review_could_better_staff_attitude");

    companion object {
        val all: List<ReviewCouldBeBetterAspect> = entries
        const val MAX_SELECTION = 3
    }
}
